export default "__VITE_ASSET__mZDkPDvd__"